import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function NotFound() {
  return (
    <section data-testid="not-found-page" className="mx-auto max-w-7xl px-5 sm:px-8 py-32 text-center">
      <div className="label-eyebrow text-slate-500">404</div>
      <h1 className="font-display text-5xl md:text-7xl font-extrabold tracking-tighter text-slate-900 mt-4">
        Page not found.
      </h1>
      <p className="mt-5 text-slate-600 text-lg max-w-xl mx-auto">
        The page you're looking for doesn't exist or has moved.
      </p>
      <Link
        to="/"
        data-testid="not-found-home-link"
        className="mt-10 inline-flex items-center gap-2 bg-[#00E676] text-slate-900 px-6 py-3.5 font-semibold hover:bg-[#00C853] transition-colors"
      >
        <ArrowLeft className="h-4 w-4" /> Back to Home
      </Link>
    </section>
  );
}
